import * as LiquidationsListActions from './list';
import * as LiquidationsByDaysActions from './kpiByDays';

const Actions = {
  ...LiquidationsListActions,
  ...LiquidationsByDaysActions,
};

export default Actions;
